"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockedPaymentCartItem = void 0;
const cart_item_1 = require("../cart-item");
const discount_1 = require("../discount");
exports.mockedPaymentCartItem = {
  id: 9,
  cartItemId: cart_item_1.mockedCartItemResponse.id,
  price: 7584.55,
  quantity: 2,
  discountAmount: 1338.45,
  discounts: [discount_1.mockedDiscountResponseDtoExceptProductsAndPriceList]
};